import React, { useEffect, useMemo, useState } from "react";
import { ChevronLeft } from "lucide-react";
import moment from "moment";

import { useAtom } from "jotai";



import { activeChildDetail } from "../../atomstore/store";
import { useRequestProcessor } from "../../requestProcessor";
import SpinnerLoading from "./SpinnerLoading";
import { fetchNews } from "../../queryfunctions/queryfunctions";
import { useNavigate } from "react-router-dom";
import CustomSelect from "./CustomSelect";

const NewsRoom = () => {
    const navigate = useNavigate();
    const { useQueryWrapper } = useRequestProcessor();
    const [activeChild] = useAtom(activeChildDetail);

    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const [selectedMonth, setSelectedMonth] = useState({
        month: moment().format("MM"),
        year: moment().format("YYYY"),
    });

    /** Build academic month list */
    const academicMonths = useMemo(() => {
        const months = [];
        const current = moment();
        const currentMonthIndex = current.month();
        const currentYear = current.year();

        let startYear = currentMonthIndex < 3 ? currentYear - 1 : currentYear;

        for (let i = 0; i < 12; i++) {
            const monthIndex = (3 + i) % 12;
            const year = monthIndex < 3 ? startYear + 1 : startYear;

            if (year > currentYear || (year === currentYear && monthIndex > currentMonthIndex)) break;

            months.push({
                label: moment().month(monthIndex).format("MMMM"),
                value: {
                    month: String(monthIndex + 1).padStart(2, "0"),
                    year: String(year),
                },
            });
        }
        return months;
    }, []);

    /** API Call */
    const { data: news, isLoading } = useQueryWrapper(
        ["news", activeChild?.id, selectedMonth],
        () => fetchNews(selectedMonth),
        {
            onSuccess: (data) =>
                console.log("[News Room] API Response:", data),
        }
    );

    const validNews = Array.isArray(news)
        ? news.filter(
            (n) =>
                typeof n.notification_subject === "string" &&
                n.notification_subject.trim() !== ""
        )
        : [];

    const openModal = (item) => {
        setSelectedItem(item);
        setShowModal(true);
    };

    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            {/* Header */}
            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={() => navigate(-1)}>News Room</h2>
            </div>

            {/* Month Filter */}
            <div className="p-4">
                <CustomSelect
                    value={`${selectedMonth.year}-${selectedMonth.month}`}
                    onChange={(val) => {
                        const [year, month] = val.split("-");
                        setSelectedMonth({ year, month });
                    }}
                    options={academicMonths.map((m, i) => ({
                        value: `${m.value.year}-${m.value.month}`,
                        label: m.label,
                    }))}
                    placeholder="Select Month"
                />
            </div>

            {/* Content */}
            <div className="p-4 space-y-4">
                {isLoading && <SpinnerLoading />}

                {!isLoading && validNews.length === 0 && (
                    <p className="text-center text-gray-500">No News Found</p>
                )}

                {validNews.map((item, idx) => (
                    <div
                        key={idx}
                        className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 cursor-pointer"
                        onClick={() => openModal(item)}
                    >
                        <div className="flex items-start justify-between mb-2">
                            <span
                                className={`text-xs px-3 py-1 rounded-full font-medium bg-blue-100 text-blue-700`}
                            >
                                News
                            </span>
                            <span className="text-xs text-gray-500">
                                {moment(item.newsletter_sent_on).format("DD MMM YYYY")}
                            </span>
                        </div>

                        <h3 className="font-bold text-gray-800 mb-2">
                            {item.notification_subject}
                        </h3>

                        <p className="text-sm text-gray-600 line-clamp-2">
                            {/* clean preview text */}
                            {/* {item.notification_text.replace(/<[^>]+>/g, "").slice(0, 120)}... */}
                        </p>
                    </div>
                ))}
            </div>

            {/* MODAL */}
            {showModal && selectedItem && (
                <div
                    className="fixed inset-0 bg-black/40 flex justify-center items-center z-[60]"
                    onClick={() => setShowModal(false)}
                >
                    <div
                        className="bg-white rounded-2xl w-11/12 max-h-[85vh] overflow-y-auto p-4"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center mb-3">
                            <h2 className="font-bold text-lg">
                                {moment(selectedItem.newsletter_sent_on).format("MMM DD, YYYY")}
                            </h2>
                            <button onClick={() => setShowModal(false)}>✕</button>
                        </div>

                        <div
                            className="prose max-w-none"
                            dangerouslySetInnerHTML={{
                                __html: selectedItem.notification_text,
                            }}
                        ></div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewsRoom;
